/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import ReactDOM from "react-dom";
import FocusTrap from "focus-trap-react";
import { chevron_left } from "../../pngs";
import { getImg } from "../../utils";
import "./CoalitionModal.scss";

export const CoalitionModal = ({
  onClickOutside,
  onKeyDown,
  modalRef,
  title,
  closeModal,
  children,
}) => {
  return ReactDOM.createPortal(
    <FocusTrap>
      <aside
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className="modal-cover"
        onClick={onClickOutside}
        onKeyDown={onKeyDown}
      >
        <div className="modal-area" ref={modalRef}>
          <ModalHeader closeModal={closeModal} title={title} />
          <div className="modal-body">{children}</div>
        </div>
      </aside>
    </FocusTrap>,
    document.body
  );
};

const ModalHeader = ({ closeModal, title }) => (
  <div className="modal-header">
    <button className="close-button" onClick={closeModal}>
      {getImg(chevron_left)}
    </button>
    <h4 className="modal-header-title">{title}</h4>
  </div>
);
